module.exports = __webpack_public_path__ + "static/RamenJap-8e18986a11b8e8fa7bcfd8291398bb2e.png";